import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'react-datepicker/dist/react-datepicker.css';
import { ReportDisplaySection } from '../../components';
import { getAllMRSItesReports, getgridHeaders, getMRSitesReports } from 'apiServices/reducer/apiService';
import { useNavigate } from 'react-router-dom';
import PMRService from "../../services/pmrservice";

import { mrSitesReportsGetByReportID } from 'apiServices/reducer/apiService';
import { head } from 'lodash';

const ViewSharedReports = ({ token, userId, isExternalUser, accessType, isAccess, selectedCategory, activeTabfromUserAnalytics, PDFURL, selectedReportIDIndex, isReportPreviewLoadingFromParent = false, OnclearPDF }) => {
    const gridRef = useRef(null);
    const previewContainerRef = useRef(null);
    const iframeRef = useRef(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const categoryData = useSelector((state) => state.apiService.login.categories);
    console.log("ViewSharedReports rendered with props:", { token, userId, isExternalUser, accessType, isAccess });

    // State variables
    const [searchQuery, setSearchQuery] = useState("");
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [reportData, setReportData] = useState([]);
    const [selectedReport, setSelectedReport] = useState(null);
    const [togglePDF, setTogglePDF] = useState(true);
    const [selectedReportName, setSelectedReportName] = useState("");
    const [selectedReportID, setSelectedReportID] = useState("");
    const [pdfUrl, setPdfUrl] = useState(null);
    const [rowData, setRowData] = useState([]);
    const [activeTab, setActiveTab] = useState(selectedCategory || "All");
    const [isLoading, setIsLoading] = useState(true);
    const [isReportPreviewLoading, setIsReportPreviewLoading] = useState(false);
    const [contactName, setContactName] = useState("");
    const [selectedReportIndex, setSelectedReportIndex] = useState(null);
    const menuData = useSelector((state) => state.apiService.sharedReportsValidateCode);
    console.log(menuData, "menuData")

    // Column definitions for the grid
    const columnDefs = [
        {
            headerName: 'Report Name',
            field: 'name',
            sortable: true,
            filter: true,
            flex: 2,
            tooltipField: 'name',
            headerTooltip: 'Report Name',
            cellRenderer: params => {
                return params.value || 'N/A';
            }
        },
        {
            headerName: 'Report Date',
            field: 'date',
            sortable: true,
            filter: true,
            width: 130,
            tooltipField: 'date',
            headerTooltip: 'Report Date',
            valueFormatter: (params) => {
                if (params.value) {
                    return new Date(params.value).toLocaleDateString();
                }
                return 'N/A';
            }
        },
        {
            headerName: 'Source',
            field: 'source',
            sortable: true,
            filter: true,
            width: 150,
            tooltipField: 'source',
            headerTooltip: 'Source',
            cellRenderer: params => {
                return params.value || 'N/A';
            }
        },
    ];

    const [rowDatanew, setRowDatanew] = useState([{
        name: "",
        date: "",
        category: "",
        clinic: "",
        url: '',
        reportId: ''
    }]);

    const [gridHeaders, setGridHeaers] = useState([
        // { name: 'All', id: 0 },
        // { name: 'Imaging', id: 2 },
        // { name: 'Blood work', id: 3 },
        // { name: 'Cardiology', id: 4 },
        // { name: 'Gastroenterology', id: 5 },
        // { name: 'Neurology', id: 6 },
        // { name: 'Prescriptions', id: 9 }
    ]);

    const [viewReportData, setViewReportData] = useState({
        ReportGroupName: '',
        ProviderName: '',
        HospitalName: '',
        UserID: userId,
        SearchKey: searchQuery,
        ReportDateStart: null,
        ReportDateEnd: null,
        SiteID: '',
        token: token,
        IncludeArchived: false
    });
    // Fetch reports data
    const fetchReports = (activeTabParam, searchValue = "") => {
        console.log(activeTabParam, "activeTabParam for fetchreports")
        console.log("MenuData reports:", menuData?.reports);
        setIsLoading(true);

        try {
            // Use menuData.reports directly instead of API call
            const fetchedData = menuData?.reports || [];

            // Extract contact_name from menuData
            if (menuData?.user_name) {
                setContactName(menuData.user_name);
            } else {
                setContactName("");
            }

            console.log("Fetched reports from menuData:", fetchedData);

            if (fetchedData.length > 0) {
                // Process the reports data to match grid structure
                let processedReports = fetchedData.map(report => ({
                    name: report.report_name || '',
                    date: report.report_date || '', // Using current date as menuData doesn't have report_date
                    source: report.source || '', // Default source since not available in menuData
                    reportId: report.report_id || '',
                    url: report.report_path || '',
                    category: report.group_name || 'General', // Use group_name for proper categorization
                    clinic: menuData?.external_user_name || 'External Source', // Using external_user_name as clinic
                    edit_report_name: report.report_name || '',
                    group_id: report.group_id || 0,
                    report_id: report.report_id || '',
                    group_name: report.group_name || '',
                    provider_name: report.provider_name || '',
                    hospital_name: report.hospital_name || ''
                }));

                // Apply search filter if search value is provided
                if (searchValue && searchValue.trim() !== '') {
                    processedReports = processedReports.filter(report =>
                        report.name.toLowerCase().includes(searchValue.toLowerCase()) ||
                        report.source.toLowerCase().includes(searchValue.toLowerCase()) ||
                        report.clinic.toLowerCase().includes(searchValue.toLowerCase())
                    );
                }

                console.log("Processed reports:", processedReports);

                const finalCategoryReport = processedReports;

                console.log("activeTabfromUserAnalytics", activeTabfromUserAnalytics);

                // Set activeTab from props when provided from menu analytics
                if (activeTabfromUserAnalytics && !activeTabParam) {
                    setActiveTab(activeTabfromUserAnalytics);
                }

                // Filter based on the passed activeTab parameter or activeTabfromUserAnalytics
                const currentTab = activeTabParam || activeTabfromUserAnalytics || activeTab;
                if (currentTab === 'All') {
                    setRowData(finalCategoryReport);
                    setRowDatanew(finalCategoryReport);
                } else {
                    const filteredReports = finalCategoryReport.filter(report => report.category === currentTab);
                    setRowData(filteredReports);
                    setRowDatanew(finalCategoryReport);
                }
                console.log(selectedReportIDIndex, "selectedReportIDIndex")

            } else {
                console.log("No reports found in menuData");
                setRowData([]);
                setRowDatanew([]);
            }

        } catch (error) {
            console.error("Error processing menuData reports:", error);
            setRowData([]);
            setRowDatanew([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        console.log(activeTab, "activeTab useeffect")
        fetchReports(activeTab);
    }, [token, gridHeaders]);
    useEffect(() => {
        if (rowData.length > 0 && selectedReportIDIndex) {
            const selectedIndex = rowData.findIndex(report => report.reportId === selectedReportIDIndex);
            const selectedReport = rowData[selectedIndex];
            console.log(rowData[selectedIndex].name, "selectedIndex")
            const name = rowData[selectedIndex].name;
            console.log(name, "name")
            if (selectedIndex !== -1) {
                setSelectedReportIndex(selectedIndex);
                setSelectedReport(selectedReport);
                setSelectedReportName(selectedReport.name);
                setSelectedReportID(selectedReport.reportId);
            }
        }
    }, [rowData, selectedReportIDIndex]);

    useEffect(() => {
        const effectiveToken = token || menuData?.Token;
        const effectiveUserId = userId || menuData?.user_id;

        if (!effectiveToken || !effectiveUserId) {
            console.warn("Missing required data for fetching grid headers:", { token: effectiveToken, userId: effectiveUserId });
            return;
        }

        const params = {
            token: effectiveToken,
            user_id: effectiveUserId,
            SiteID: 0,
            Active: true
        };

        console.log("Fetching grid headers with params:", params);

        dispatch(getgridHeaders(params))
            .then((response) => {

                if (response.payload && Array.isArray(response.payload)) {
                    // Add "All" option at the beginning
                    const headersWithAll = [
                        // { name: 'All', id: 0 },
                        ...response.payload
                    ];
                    const headerdata = []

                    headerdata.push({ name: "All", id: 0 });
                    headersWithAll.forEach(header => {
                        const existsInCategory = categoryData.some(category => category.category_name === header.name);
                        console.log("Grid headers response:", response);

                        if (categoryData.length > 0) {
                            if (existsInCategory) {
                                headerdata.push({ name: header.name, id: header.id });
                            }
                        } else {
                            headerdata.push({ name: header.name, id: header.id });
                        }
                    });
                    console.log(headerdata, "categoryGridHeaders")

                    setGridHeaers(headerdata);

                    console.log("Grid headers set with 'All' option:", headersWithAll);
                } else {
                    console.warn("Invalid grid headers response format:", response.payload);

                }
            })
            .catch((error) => {
                console.error("Error fetching grid headers:", error);
            });
    }, [token, userId, activeTab]);

    // Update activeTab when selectedCategory prop changes
    useEffect(() => {
        if (selectedCategory && selectedCategory !== activeTab) {
            setActiveTab(selectedCategory);
            setSelectedReport(null);
            setPdfUrl(null);
            setIsReportPreviewLoading(false);
            setSearchQuery("");
            fetchReports(selectedCategory);
        }
        console.log(activeTab, "activeTab useeffect")
    }, [selectedCategory]);

    // Update activeTab when activeTabfromUserAnalytics prop changes
    useEffect(() => {
        if (activeTabfromUserAnalytics && activeTabfromUserAnalytics !== activeTab) {
            setActiveTab(activeTabfromUserAnalytics);
            setSelectedReport(null);
            setPdfUrl(null);
            setIsReportPreviewLoading(false);
            setSearchQuery("");
            fetchReports(activeTabfromUserAnalytics);
        }
    }, [activeTabfromUserAnalytics]);

    // Add fullscreen change event listeners
    useEffect(() => {
        const handleFullscreenChange = () => {
            const isCurrentlyFullscreen = document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement;

            console.log('Fullscreen change detected:', isCurrentlyFullscreen ? 'Entered' : 'Exited');
            setIsFullscreen(!!isCurrentlyFullscreen);
        };

        // Add event listeners for different browsers
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        document.addEventListener('mozfullscreenchange', handleFullscreenChange);
        document.addEventListener('MSFullscreenChange', handleFullscreenChange);

        // Cleanup event listeners on component unmount
        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
            document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
            document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
        };
    }, []);

    const handleSearchClear = (event) => {
        setSearchQuery("");
        fetchReports({ searchQuery: "" });

        // Exit fullscreen mode if currently in fullscreen
        const isCurrentlyFullscreen = document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.mozFullScreenElement ||
            document.msFullscreenElement;

        if (isCurrentlyFullscreen) {
            const exitFullscreen = document.exitFullscreen ||
                document.webkitExitFullscreen ||
                document.mozCancelFullScreen ||
                document.msExitFullscreen;

            if (exitFullscreen) {
                exitFullscreen.call(document)
                    .then(() => {
                        console.log('Successfully exited fullscreen mode via clear');
                        setIsFullscreen(false);
                    })
                    .catch(err => {
                        console.error(`Error attempting to exit full-screen mode via clear: ${err.message} (${err.name})`);
                        setIsFullscreen(false);
                    });
            } else {
                console.warn('Exit fullscreen not supported, using CSS fallback');
                setIsFullscreen(false);
            }
        }

        onClear();
    };

    const onRowClicked = (event) => {

        console.log(event, "event selected report")
        setReportData(event.data)

        const reportId = event.data.reportId;

        console.log("Selected Report Data:", event.data); // Print full report data

        const params = {
            ReportID: reportId,
            UserID: userId,
            token: token
        }
        setIsReportPreviewLoading(true);
        setPdfUrl(null);
        OnclearPDF?.();
        PMRService.getPMRReportsPerId(params).then(resp => {
            const blobUrl = URL.createObjectURL(resp);
            console.log('bloburl', blobUrl)
            setPdfUrl(blobUrl)
            console.log(event.data, "event selected report")

            // Set selected report with all the data including group_name, provider_name, hospital_name
            setSelectedReport(event.data)
            setSelectedReportName(event.data.name)
            setSelectedReportID(event.data.reportId)
            const rowIndex = rowData.findIndex(report => report.reportId === event.data.reportId);
            setSelectedReportIndex(rowIndex)
        }).catch((error) => {
            console.error("Error fetching report preview:", error);
            setPdfUrl(null);
        }).finally(() => {
            setIsReportPreviewLoading(false);
        })
        setTogglePDF(!togglePDF);
    };


    const onFullScreenToggle = () => {
        const elem = previewContainerRef.current;
        console.log('Fullscreen toggle clicked, element:', elem);

        if (!elem) {
            console.error('Preview container ref not found');
            return;
        }

        // Check for different fullscreen properties for browser compatibility
        const isCurrentlyFullscreen = document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.mozFullScreenElement ||
            document.msFullscreenElement;

        if (!isCurrentlyFullscreen) {
            console.log('Attempting to enter fullscreen mode');

            // Try different fullscreen methods for browser compatibility
            const requestFullscreen = elem.requestFullscreen ||
                elem.webkitRequestFullscreen ||
                elem.mozRequestFullScreen ||
                elem.msRequestFullscreen;

            if (requestFullscreen) {
                requestFullscreen.call(elem)
                    .then(() => {
                        console.log('Successfully entered fullscreen mode');
                        setIsFullscreen(true);
                    })
                    .catch(err => {
                        console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
                        // Fallback to CSS-based fullscreen
                        setIsFullscreen(true);
                    });
            } else {
                console.warn('Fullscreen API not supported, using CSS fallback');
                // Fallback to CSS-based fullscreen
                setIsFullscreen(true);
            }
        } else {
            console.log('Attempting to exit fullscreen mode');

            // Try different exit fullscreen methods for browser compatibility
            const exitFullscreen = document.exitFullscreen ||
                document.webkitExitFullscreen ||
                document.mozCancelFullScreen ||
                document.msExitFullscreen;

            if (exitFullscreen) {
                exitFullscreen.call(document)
                    .then(() => {
                        console.log('Successfully exited fullscreen mode');
                        setIsFullscreen(false);
                    })
                    .catch(err => {
                        console.error(`Error attempting to exit full-screen mode: ${err.message} (${err.name})`);
                        // Fallback to CSS-based exit
                        setIsFullscreen(false);
                    });
            } else {
                console.warn('Exit fullscreen not supported, using CSS fallback');
                // Fallback to CSS-based exit
                setIsFullscreen(false);
            }
        }
    };

    const setGridData = (event) => {
        const newActiveTab = event.name;
        setActiveTab(newActiveTab);
        setSelectedReport(null);
        setPdfUrl(null);
        setIsReportPreviewLoading(false);
        setSearchQuery("");

        setViewReportData({
            ReportGroupName: "",
            ProviderName: "",
            UserID: userId,
            HospitalName: "",
            SearchKey: searchQuery,
            ReportDateStart: "",
            ReportDateEnd: "",
            token: token,
            SiteID: '',
            IncludeArchived: false
        });

        setRowData([]);
        setPdfUrl(null);
        console.log(newActiveTab, "newActiveTab in setGridData")
        // Fetch reports for the selected tab using the new tab name directly
        fetchReports(newActiveTab);
        console.log(event.name, "event.name")
    };

    const onViewTrends = () => {
        console.log("View trends clicked");
    };

    const onCompareReports = () => {
        console.log("Compare reports clicked");
    };

    const handleNotes = () => {
        console.log("Handle notes clicked");
    };


    console.log("ViewSharedReports rendering with:", { isLoading, rowData: rowData.length, searchQuery });
    console.log("Current grid headers:", gridHeaders);

    const clearReportPreview = () => {
        OnclearPDF?.();

        setPdfUrl((prev) => {
            if (prev && typeof prev === 'string' && prev.startsWith('blob:')) {
                URL.revokeObjectURL(prev);
            }
            return null;
        });
        setSelectedReport(null);
        setSelectedReportName("");
        setSelectedReportID("");
        setSelectedReportIndex(null);
        setIsReportPreviewLoading(false);
    };

    const onClear = (event) => {
        setSearchQuery("");
        OnclearPDF?.();

        const updatedViewReportData = {
            ...viewReportData,
            SearchKey: "",
            ReportGroupName: "",
            ProviderName: "",
            HospitalName: "",
            ReportDateStart: null,
            ReportDateEnd: null
        };
        setViewReportData(updatedViewReportData);

        // Exit fullscreen mode if currently in fullscreen
        const isCurrentlyFullscreen = document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.mozFullScreenElement ||
            document.msFullscreenElement;

        if (isCurrentlyFullscreen) {
            const exitFullscreen = document.exitFullscreen ||
                document.webkitExitFullscreen ||
                document.mozCancelFullScreen ||
                document.msExitFullscreen;

            if (exitFullscreen) {
                exitFullscreen.call(document)
                    .then(() => {
                        console.log('Successfully exited fullscreen mode via onClear');
                        setIsFullscreen(false);
                    })
                    .catch(err => {
                        console.error(`Error attempting to exit full-screen mode via onClear: ${err.message} (${err.name})`);
                        setIsFullscreen(false);
                    });
            } else {
                console.warn('Exit fullscreen not supported, using CSS fallback');
                setIsFullscreen(false);
            }
        }

        clearReportPreview();

        // Use fetchReports to maintain consistency and proper tab filtering
        fetchReports(activeTab);
    };


    const onSearch = (event) => {
        clearReportPreview();
        const searchValue = event.target.value;
        setSearchQuery(searchValue);

        // Use fetchReports with search value to maintain consistency and proper tab filtering
        fetchReports(activeTab, searchValue);
    };


    return (
        <div className="container-fluid">
            <div className="row mb-3">
                <div className="col-12">
                    <ReportDisplaySection
                        // Search Props
                        searchQuery={searchQuery}
                        onSearchChange={(e) => onSearch(e)}
                        onSearchClear={handleSearchClear}
                        // Tab Props
                        gridHeaders={gridHeaders}
                        activeTab={activeTab}
                        onTabClick={(tab) => setGridData(tab)}
                        rowDatanew={rowDatanew}
                        // Grid Props
                        gridRef={gridRef}
                        rowData={rowData}
                        columnDefs={columnDefs}
                        onRowClicked={onRowClicked}
                        // Preview Props
                        previewContainerRef={previewContainerRef}
                        isFullscreen={isFullscreen}
                        pdfUrl={PDFURL?PDFURL:pdfUrl}
                        isReportPreviewLoading={isReportPreviewLoadingFromParent || isReportPreviewLoading}
                        selectedReport={selectedReport}
                        selectedReportID={selectedReportID}
                        selectedReportName={selectedReportName}
                        onFullScreenToggle={onFullScreenToggle}
                        iframeRef={iframeRef}
                        onViewTrends={onViewTrends}
                        onCompareReports={onCompareReports}
                        isProvider={false}
                        handleNotes={handleNotes}
                        includeArchive={false}
                        isAccess={true}
                        contactName={contactName}
                        handleClear={onClear}
                        selectedRow={selectedReportIndex}
                        hidePdfToolbar={true}
                    />
                </div>
            </div>
        </div>
    );
};

export default ViewSharedReports; 